(function ($) {
  function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase();
    });
  }

  function findInStr(string, search) {
    return string.indexOf(search) > -1;
  }

  var sendGoogleAnalyticsEvent = function (opts) {
    if (typeof ga != 'function') {
      console.error('GA not defined');
      return false;
    }

    console.log('++ >>SEND GA EVENT: ' + JSON.stringify(opts));
    ga('send', {
      hitType: 'event',
      eventCategory: opts.category,
      eventAction: opts.action,
      eventLabel: opts.label,
      transport: 'beacon',
      nonInteraction: opts.noninteraction
    });
  }

  $('body').on('click', 'a', function (e) {
    var sendGA = true,
        $this = $(this),
        sid = 'content',
        url = new window.URL($this.attr('href'), window.location.origin),
        href = url.href,
        text = $this[0].childNodes[0].nodeValue ? $this[0].childNodes[0].nodeValue.trim() : '',
        page = window.themeOptions.template == 'index' ? 'Home' : window.themeOptions.page,
        opts = {
          category: "",
          action: "",
          label: "",
          noninteraction: false
        }; //category, action, label, ni

    //don't send an event! 
    /*if (!findInStr(url.host, window.location.hostname) && !$this.hasClass('contact-links-item__link')) {
        console.log('++ ignore event 1', href);
        sendGA = false;
      } else*/ 
    if ($this.attr('href').indexOf('#') == 0 && window.themeOptions.template != 'product' && !$this[0].hasAttribute("data-video") && window.themeOptions.template_suffix != "faqs") {
      //console.log('++ ignore event 1', href);
      sendGA = false;
    } else if ($this.attr('href').indexOf('javascript') == 0) {
      ///console.log('++ ignore event 2', href);
      sendGA = false;
    } else if (typeof $this.attr('data-mobile-submenu-trigger') != 'undefined') {
      //console.log('++ ignore event 3', href);
      sendGA = false;
    } else {
      //Passes, do the rest of the checks

      // overrides to match analytics
      if (text == 'Best Sellers') {
        text = 'Bestsellers';
      }
      if (text == 'Shop All') {
        text = 'All';
      }
      if ($this.attr('title') == 'Login or register') {
        text = 'Log In or Register';
      }
      switch ($this.closest('[data-section-id]').attr('data-section-id')) {
        case 'footer':
          sid = 'footer';
          break;
        case 'mobile-nav':
        case 'header':
          sid = 'header';
          break;
        default:
          sid = 'content';
          break;
      }
      if (page == '') {
        page = window.themeOptions.template;
      }

      if (findInStr(url.host, window.location.hostname) && findInStr(href, 'product')) {
        // clicked ON a product
        opts.category = 'Product_Detail';
        opts.label = $this.closest('.product_item--inner, .product-card').find('.product_item--title, .product-card__info-title').text().trim();

        if (page == 'product') {
          // clicked on product from a product
          opts.action = 'ProductViewedFrom_' + window.themeOptions.page_title;
        } else if (page == 'collection') {
          // clicked on product from a collection
          opts.action = 'ProductViewedFrom_' + window.themeOptions.collection;
        } else if (page == 'Shop') {
          opts.action = 'ProductViewedFrom_ShopAll';
        } else {
          opts.action = 'ProductViewedFrom_' + page;
        }

      } else if (window.themeOptions.template == 'product' && $this.closest('.product-detail__description') && $this.attr('href').indexOf('#') == 0) {
        // we are ON a product page and clicking the tabs
        opts.category = 'Product_Detail';
        opts.label = window.themeOptions.page_title;
        opts.noninteraction = true;

        switch (url.hash) {
          case '#reviews':
            opts.action = 'Product_Detail_Viewed_Reviews';
            break;
          case '#recipes':
            opts.action = 'Product_Detail_Viewed_Recipes';
            break;
          case '#faqs':
            opts.action = 'Product_Detail_Viewed_FAQs';
            break;
          case '#nutrition':
            opts.action = 'Product_Detail_Viewed_Nutrition';
            break;
          default:
            opts.action = 'Product_Detail_Viewed_Highlights';
            break;
        }
      } else {
        //A REGULAR CLICK EVENT THEN
        opts.category = 'Engagement_Clicks';

        if (sid == 'footer' || sid == 'header') {
          //EVENT ACTION
          if ($this.closest('.mobile-menu__primary-sub').length > 0) {
            // is mobile header subnav
            opts.action = $this.closest('.mobile-menu__primary-sub').siblings('a')[0].childNodes[0].nodeValue.trim() + '_' + text;
          } else if ($this.closest('.header-dropdown').length > 0) {
            // is header subnav
            opts.action = $this.closest('.header-dropdown').siblings('a')[0].childNodes[0].nodeValue.trim() + '_' + text;
          } else if ($this.hasClass('is-logo')) {
            // logo clicked
            opts.action = 'Logo';
          } else if ($this.hasClass('footer--link')) {
            //is footer link
            var p = toTitleCase($this.closest('.footer--listing').find('.footer-nav__title')[0].childNodes[0].nodeValue.trim());
            if (p == 'Our Products') {
              p = 'Shop';
            }

            opts.action = p + '_' + text;

          } else {
            opts.action = text;
          }
        } else if (window.themeOptions.template == "blog" && findInStr(href, 'blogs')) {
          //clicked on a blog
          opts.category = 'Engagement_Blog';
          if ($this.closest('.slideshow__slide').length > 0) {
            opts.action = 'Recipe_Viewed_featured';
            opts.label = $this.closest('.slideshow__slide').find('.slideshow__title').text().trim();
          } else {
            opts.action = 'Recipe_Viewed_collection';
            opts.label = $this.closest('.article-card').find('.article-card__info-title').text().trim();
          }
        }else if (window.themeOptions.template == "index") {
          //clicked on homepage
          opts.category = 'Engagement_Home';
          opts.action = 'Homepage_Panel_click';
          if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1572451055703"){


            if ($(this).parents('.slideshow__slide').attr('id') == "slide-1"){
              opts.label = "Slider Spotlight 1 CTA Click"; 
            }
            if ($(this).parents('.slideshow__slide').attr('id') == "slide-2"){
              opts.label = "Slider Spotlight 2 CTA Click";   
            }
            if ($(this).parents('.slideshow__slide').attr('id') == "slide-3"){
              opts.label = "Slider Spotlight 3 CTA Click";   
              opts.noninteraction = true;
            }
            if ($(this).parents('.slideshow__slide').attr('id') == "slide-4"){
              opts.label = "Slider Spotlight 4 CTA Click";              
            }
            if ($(this).parents('.slideshow__slide').attr('id') == "slide-5"){
              opts.label = "Slider Spotlight 5 CTA Click";              
            }
            if ($(this).is("a.Button.retailer-1") || $(this).is("a.Button.retailer-2")){
              opts.category = 'Retailer_Clicks';
              opts.action = $(this).attr('href');                  
              opts.label = "ClickedFrom_homepage"; 
            }
          }
          if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1572751477861"){
            opts.label = "Panel 2 CTA Click";
          }
          if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1571840727419"){
            opts.label = "Panel 3 CTA Click";
          }
          if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1572751621235"){
            opts.label = "Panel 4 CTA Click";
          }
          if ($(this).parents('.shopify-section').attr('id') == "shopify-section-1575579950054"){
            opts.label = "Panel 5 CTA Click";
          }


        }
        else if (window.themeOptions.template_suffix == "faqs" && $this.attr('href').indexOf('#') == 0 && $this.closest('.faqs__tabs').length > 0) {
          //FAQ main section on desktop
          //rest of FAQ below
          opts.category = 'Engagement_FAQ';
          opts.action = 'FAQ_Section_Viewed';
          opts.label = $this.text().trim();
          opts.noninteraction = true;
        } else if ($this.hasClass('contact-links-item__link')) {
          // contact us
          opts.category = 'Engagement_Contact';
          opts.action = 'EmailUs_Selected';
          opts.label = text;
        } else if (text.toLowerCase() == 'follow us') {
          opts.category = 'Engagement_Social';
          opts.action = 'FollowUs_Selected';
          opts.label = 'ClickedFrom_'+page;
        } else if ( $this.closest('.social-sharing').length > 0) {
          opts.category = 'Engagement_Social';
          if (findInStr(href, 'mailto')){
            opts.action = 'Share_Email';
            opts.noninteraction = true;
          } else {
            var u = url.host.split('.');
            opts.action = 'Share_'+toTitleCase(u[u.length-2]);
          }
          opts.label = page;
        } else {
          // its in the content...
          if (findInStr(href, 'page')) {
            // for pages
            if (findInStr(href, 'our-mission')) {
              opts.action = 'Who We Are_Mission & Values';
            } else if (findInStr(href, 'queen-califia')) {
              opts.action = 'Who We Are_Queen Califia';
            } else if (findInStr(href, 'why-plant-based')) {
              opts.action = 'What Plants Can Do';
            } else if (findInStr(href, 'shop')) {
              opts.action = 'Shop_All';
            } else if (findInStr(href, 'find-your-plant-base')) {
              opts.action = 'Find Califia';
            } else if (findInStr(href, 'email-signup-page')) {
              opts.action = 'Email Sign-Up';
            } else if (findInStr(href, 'contact-us')) {
              opts.action = 'Contact Us';
            } else if (findInStr(href, 'united-kingdom')) {
              opts.action = 'UK';
            } else if (findInStr(href, 'australia')) {
              opts.action = 'Australia';
            } else if (findInStr(href, 'press')) {
              opts.action = 'Press';
            }
          } else if (findInStr(href, 'collections')) {
            //for shop collections
            if (findInStr(href, 'best-sellers')) {
              opts.action = 'Shop_Bestsellers';
            } else if (findInStr(href, 'plant-milks')) {
              opts.action = 'Shop_Plant Milk';
            } else if (findInStr(href, 'cold-brew-coffees')) {
              opts.action = 'Shop_Cold Brew Coffee';
            } else if (findInStr(href, 'creamers')) {
              opts.action = 'Shop_Creamer';
            } else if (findInStr(href, 'yogurt')) {
              opts.action = 'Shop_Yogurt';
            } else if (findInStr(href, 'juices')) {
              opts.action = 'Shop_Juice';
            } else if (findInStr(href, 'seasonal')) {
              opts.action = 'Shop_Seasonal';
            }
          } else if (findInStr(href, 'blogs/the-bounty')) {
            // for blogs
            opts.action = 'Blog';
          } else if (findInStr(href, 'account/login')) {
            opts.action = 'Log In or Register';
          } else if (findInStr(href, 'cart') && page != 'cart') {
            opts.action = 'View Cart';
          } else {
            // NOPE
            //console.log('++ ignore event from content', opts);
            sendGA = false;
          }
        }

        if (url.searchParams.has('checkout_url')) {
          // for Log In or Register
          opts.label = 'ClickedFrom_Checkout';
        } else if ($this.closest('.ajax-cart').length > 0) {
          // For View Cart
          opts.label = 'ClickedFrom_AddToCart';
        } else if (sid == 'header') {
          // upper nav
          opts.label = 'ClickedFrom_UpperNavigation_' + page;
        } else if (sid == 'footer') {
          // lower nav
          opts.label = 'ClickedFrom_LowerNavigation_' + page;
        } else if (opts.label == '') {
          // content
          opts.label = 'ClickedFrom_Content_' + page;
        }
      }

      if (opts.category == '' || opts.action == '') {
        //console.log('++ ignore event final', opts);
        sendGA = false;
      } else {
        sendGoogleAnalyticsEvent(opts);
      }
    }
  });


  // on FAQ click
  if (window.themeOptions.template_suffix == "faqs") {
    //FAQ all mobile and desktop question click
    $('.faqs-category__question').on('click', function () {
      if (!$(this).hasClass('opened')) {
        if ($(this).find('.tabTitle').length > 0) {
          var act = 'FAQ_Section_Viewed';
        } else {
          var act = 'FAQ_Section_Expanded';
        }
        sendGoogleAnalyticsEvent({
          category: 'Engagement_FAQ',
          action: act,
          label: $(this).text().trim(),
          noninteraction: true
        });
      }
    });
  }

  // on add to cart
  $('[data-add-to-cart]').on('click', function () {
    var onetime = $('[data-product-subscription-price]:checked').val() == 'autodeliver' ? 'Subscription' : 'One-TimePurchase';
    sendGoogleAnalyticsEvent({
      category: 'Conversion_AddToCart',
      action: onetime,
      label: window.themeOptions.page_title,
      noninteraction: true
    });
  });
  
  // on Klaviyo Newsletter submit
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'submit') {
      var from = e.detail.metaData.$source;
      sendGoogleAnalyticsEvent({
        category: 'Newsletter_Subscription',
        action: 'Subscription_Submitted',
        label: from,
        noninteraction: true
      });
    }
  });

  setTimeout(function () {
    // on email signup
    $('.subscribe__form').on('submit', function () {
      var from = 'From_SignUpPage';
      sendGoogleAnalyticsEvent({
        category: 'Engagement_EmailSignUp',
        action: 'EmailSIgnUp_Success',
        label: from,
        noninteraction: true
      });
    });

    // on login fail    
    if ($('#customer_login .errors').length > 0) {
      var reason = $('#customer_login .errors').text().trim();
      sendGoogleAnalyticsEvent({
        category: 'Engagement_Account',
        action: 'Login_Error',
        label: reason,
        noninteraction: true
      });
    }

    //on login success?
    if ($('body').attr('id') == 'account') {
      if (findInStr(document.referrer, 'challenge') ||
          findInStr(document.referrer, 'login')) {
        sendGoogleAnalyticsEvent({
          category: 'Engagement_Account',
          action: 'Login_Success',
          label: '',
          noninteraction: true
        });
      }
    }

    // on register fail
    if ($('#create_customer .errors').length > 0) {
      var reason = $('#create_customer .errors').text().trim();
      sendGoogleAnalyticsEvent({
        category: 'Engagement_Account',
        action: 'Login_Error',
        label: reason,
        noninteraction: true
      });
    }

    //on review submit
    $('input.yotpo-default-button').on('click', function () {
      sendGoogleAnalyticsEvent({
        category: 'Product_Detail',
        action: 'Product_Review_Submitted',
        label: window.themeOptions.page_title,
        noninteraction: true
      });
    });

    /* *************************************
     * TEMPLATED LANDING PAGE (TLP) EVENTS *
     ************************************* */

    /**
       * ENGAGEMENT CLICK EVENT
       * Engagement_Home / LP_{{TLP NAME}}_Panel_click / Panel {{PANEL NUMBER}} CTA Click
       */
    $('.template-landing-page .template-panel a, .template-landing-page .template-panel .cta-play-button').on('click', function () {
      var tlpName = window.themeOptions.page_title;
      var panelNum = $(event.currentTarget).parents('.template-panel').data('template-panel');
      //console.debug('-- DEBUG: ga click: engagement, '+tlpName+' panel '+panelNum);
      sendGoogleAnalyticsEvent({
        category: 'Engagement_Home',
        action: 'LP_'+tlpName+"_Panel_click",
        label: 'Panel '+panelNum+' CTA Click'
        //           , noninteraction: false
      });
    });

    /**
       * CTA CLICK EVENT
       * Engagement_Clicks / {{SHOPIFY Site Section}} / Content_LP_{{TLP NAME}}
       */
    $('.template-landing-page .template-panel a, .template-landing-page .template-panel .cta-play-button').on('click', function () {
      var tlpName = window.themeOptions.page_title;
      var section = $(event.currentTarget).parents('.template-panel').data('template-section');
      //console.debug('-- DEBUG: ga click: cta, '+section+' from '+tlpName);
      sendGoogleAnalyticsEvent({
        category: 'Engagement_Clicks',
        action: section,
        label: 'Content_LP_'+tlpName
        //           , noninteraction: false
      });
    });

    /**
       * CTA CAROUSEL EVENT
       * Engagement_Carousel / {{SHOPIFY Site Section}} / Content_LP_{{TLP NAME}}
       *//* commented by Christina Park request
    $('.template-panel .slick-slider').on('swipe', function(event, slick, direction){
      var tlpName = window.themeOptions.page_title;
      var section = $(event.currentTarget).parents('.template-panel').data('template-section');
      console.debug('-- DEBUG: ga carousel: swipe, '+section+' from '+tlpName);
      sendGoogleAnalyticsEvent({
        category: 'Engagement_Carousel',
        action: section+' swipe',
        label: 'Content_LP_'+tlpName
        //           , noninteraction: false
      });
    });*/

    /**
       * RETAILER CLICK EVENT
       * Retailer_Clicks / {{RETAILER NAME}} / ClickedFrom_LP_{{TLP NAME}}
       */
    $('.whereis-block .whereis-store-wrapper a').on('click', function () {
      var tlpName = window.themeOptions.page_title;
      var retailer = $(event.currentTarget).attr('name');
      //console.debug('-- DEBUG: ga click: retailer, '+retailer+' from '+tlpName);
      sendGoogleAnalyticsEvent({
        category: 'Retailer_Clicks',
        action: retailer,
        label: 'ClickedFrom_LP_'+tlpName
        //           , noninteraction: false
      });
    });

  }, 2000);
})(jQuery);
